<template lang="pug">
.bluetooth-frame(style="width: 500px")
  .bluetooth-header.d-flex.flex-column.justify-content-center.align-items-center.px-5.flex-grow-1
    .status-text.h3.text-center
      .font-weight-light {{ $t("Bluetooth is available.") }}
      .font-weight-bold {{ $t("You can connect now!") }}
    .device-name.border.px-5.py-3.my-5.h3 {{ name }}
    img(src="@/assets/images/bluetooth.png")
  .bluetooth-footer.pb-5.text-center
    pr-button.themed(small, v-nv.current, outline, @nv-enter="$emit('close')") {{ $t("Close") }}
</template>

<script>
export default {
  name: "bluetooth",
  data() {
    return {
      name: null
    }
  },
  async mounted() {
    this.$emit("ready")
    _$.nav.sync("sideload", true)
    this.name = await __.device.getName()
    _$.vue.$on("applicationUnfocused", () => this.$emit("close"))
  }
}
</script>

<style lang="scss">
.bluetooth-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
